import { Option } from '../DropDown/props';

export const week: Option[] = [
  { id: "1", name: "All" },
  { id: "2", name: "Today" },
  { id: "3", name: "Tomorrow" },
  { id: "4", name: "Yesterday" },
  { id: "8", name: "Current Week" },
  { id: "10", name: "Next Week" },
  { id: "9", name: "Last Week" },
  { id: "5", name: "Last 7 Days" },
  { id: "6", name: "Last Month" },
  { id: "7", name: "Custom" },
];
